import React from "react";
import s from "./s.module.scss";

function About() {
  return (
    <div className="App">
      <header className={s.color}>About</header>
    </div>
  );
}

export default About;
